'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
react.Heading.displayName = 'Heading';
Object.defineProperty(exports, 'Heading', {
  enumerable: true,
  get: function () {
    return react.Heading;
  }
});